import { render, staticRenderFns } from "./ArtistsAccomodation.vue?vue&type=template&id=3d803e2e&"
import script from "./ArtistsAccomodation.vue?vue&type=script&lang=js&"
export * from "./ArtistsAccomodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports